import {Table, DataTable} from '@primer/react/experimental'
import type {PreviewPayload} from '../types'
import {Preview} from './preview'
import {BranchName, Checkbox} from '@primer/react'

export type PreviewsTableProps = {
  previews: PreviewPayload
}

export function PreviewsTable({previews}: PreviewsTableProps) {
  const previewsWithId =
    previews?.map(preview => ({
      ...preview,
      id: preview.targetedBranches,
    })) ?? []

  return (
    <>
      <h2 className="sr-only" id="previews-table">
        Ruleset previews
      </h2>
      <Table.Container>
        <DataTable
          aria-labelledby="previews-table"
          data={previewsWithId}
          columns={[
            {
              header: 'Rule',
              field: 'targetedBranches',
              renderCell(preview) {
                return (
                  <span className="d-flex flex-row flex-items-center gap-1">
                    <Checkbox /> <BranchName>{preview.targetedBranches}</BranchName>
                  </span>
                )
              },
            },
            {
              header: 'Ruleset name',
              field: 'rulesets',
              renderCell(preview) {
                return <Preview preview={preview} />
              },
            },
          ]}
        />
      </Table.Container>
    </>
  )
}
